import React from 'react'

function SecondaryBtn({ onClick, label, children, className = '' }) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={`
        ${className}
        ms-3
        text-[#BA141B]
        bg-white
        border border-[#BA141B]/30
        hover:bg-[#BA141B]/5
        hover:text-[#BA141B]
        active:bg-[#BA141B]/10
        focus:outline-none
        focus:ring-4
        focus:ring-[#BA141B]/20
        focus:z-10
        rounded-lg
        text-sm
        font-medium
        px-5
        py-2.5
        transition-colors
        duration-150
      `}
    >
      {label || children}
    </button>
  )
}

export default SecondaryBtn